var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('row-item',{staticClass:"show-my-team-bar",attrs:{"type":_vm.type,"disabled":_vm.disabled},on:{"click":_vm.showTeamDetail}},[_vm._v("\n  查看拼团进度\n")])}
var staticRenderFns = []

export { render, staticRenderFns }